// Navigation des Moduls `people` (eager geladen; Quelle UX §2.2–§2.10). Besitzer: Modul people.
import { IdentificationCard, ListBullets, TreeStructure, UsersThree } from '@phosphor-icons/react';
import { defineMeta } from '@web/registry/define';

export default defineMeta({
  key: 'people',
  title: 'People & Organisation',
  nav: {
    people: [
      {
        key: 'people.me',
        label: 'My profile',
        icon: IdentificationCard,
        path: '/people/me',
        roles: ['ALL'],
        order: 20,
        area: 'rail',
      },
      {
        key: 'people.directory',
        label: 'People',
        icon: UsersThree,
        path: '/people',
        roles: ['ALL'],
        order: 30,
        area: 'rail',
        activeFor: ['/teams', '/departments'],
      },
      {
        key: 'people.tab.directory',
        label: 'Directory',
        icon: ListBullets,
        path: '/people',
        roles: ['ALL'],
        order: 10,
        area: 'tabs:people',
      },
      {
        key: 'people.tab.org',
        label: 'Org chart',
        icon: TreeStructure,
        path: '/people/org',
        roles: ['ALL'],
        order: 20,
        area: 'tabs:people',
      },
    ],
  },
});
